import { createFileRoute } from "@tanstack/react-router";
import { WorkingBoard } from "@/components/working/WorkingBoard";

export const Route = createFileRoute("/(protected)/_layout/working")({
  component: ServicePage,
});

/** The line during service: everything a ticket asked for. Prep lives at /prep. */
function ServicePage() {
  return <WorkingBoard source="order" from="/working" />;
}
